import "core-js/modules/es.array.concat.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "custom-component"
};
var _hoisted_2 = ["src"];
import { onMounted } from 'vue';
export default {
  __name: 'eFormula',
  props: {
    elementContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // element: {
    //   type: Object,
    //   default: () => ({}),
    // },
    edit: {
      type: Boolean,
      default: true
    }
  },
  emits: ['loaded'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    onMounted(function () {
      emit('loaded', 'eFormula');
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        src: "".concat(__props.elementContent.content, "?r=").concat(Math.random()),
        crossorigin: "anonymous",
        style: {
          "width": "100%"
        },
        draggable: "false",
        class: _normalizeClass([!__props.edit && 'preview-image'])
      }, null, 10, _hoisted_2)]);
    };
  }
};